module.exports = __webpack_public_path__ + "static/media/delete.bf9af8ae.svg";